import React, { useEffect } from 'react';
import { getConfig } from '../../utils/config';
import Header from './Header';
import RewardCategory from './RewardCategory';
import useData from './data';
import DealSection from '../DealsAndDiscounts/Components/DealSection';
import { truncate } from '../../helpers';
import RewardsGuide from './RewardsGuide';
import FAQ from './FAQ';
import FooterBenefit from './FooterBenefits';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SkeletonDealPage from '../../Components/Molecules/Skeleton/SkeletonDealPage';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../store/auth-slice';

const RewardPointStore = ({ isRewards }) => {
    const {
        rewards,
        isLoadingrewards,
        rewardsCategoryList,
    } = useData(isRewards);

    const config = getConfig();
    const history = useHistory();
    const dispatch = useDispatch()
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };

    useEffect(() => {
        if (!isAuthenticated) {
            openLoginModal();
        }
    }, []);




    return (
        <div className={` ${config?.darkMode ? 'bg-black' : 'bg-white'}`}>
            <div
                className={`
                    ${config?.bannerNegativeTopMarginClass} w-full h-auto  `}
            >
                {config?.header && (
                    <div className={config?.header.headerClass}></div>
                )}
            </div>
            <div className="px-3 lg:pl-0 w-full lg:w-[95%] lg:mx-auto lg:pt-5">
                <div className="flex justify-center w-full">
                    <Header />
                </div>


                {isLoadingrewards && <SkeletonDealPage isVisible={true} />}

                <div className="mt-6 mb-5">
                    <RewardCategory
                        rewardsCategoryList={rewardsCategoryList}
                    />
                </div>
                <div id="rewards" className="flex justify-center">
                    <DealSection
                        type="New in the House​"
                        isRewards={isRewards}
                        rewardStorePoint={true}
                        offers={rewards?.slice(0, 4)}
                        className="mt-4 lg:mt-6"
                    />
                </div>
                <button
                    className="font-medium text-[#4652A4] flex items-center justify-center text-[14px] mx-auto my-8"
                    onClick={() => history.push('/rewardStore')}
                >
                    View More Deals
                </button>
                <div className="">
                    <RewardsGuide />
                </div>
                <div className="flex justify-center w-full">
                    <FAQ />
                </div>
                <div className="flex justify-center w-full">
                    <FooterBenefit />
                </div>
            </div>
        </div>
    );
};

export default RewardPointStore;
